import { useEffect, useState } from 'react'

import TransactionStatusScreen from './screens/TransactionStatusScreen'

const TransactionStatusWidget = () => {
  const [txId, setTxId] = useState<string | null>(null)

  useEffect(() => {
    // Get transaction ID from URL parameters
    const urlParams = new URLSearchParams(window.location.search)
    const transactionId = urlParams.get('id')

    if (transactionId) {
      setTxId(transactionId)
    }
  }, [])

  const handleBack = () => {
    // Navigate back to home page
    window.location.href = '/'
  }

  // Show loading if no transaction ID found
  if (!txId) {
    return (
      <div className="w-full max-w-md mx-auto bg-white dark:bg-gray-900 rounded-3xl shadow-2xl overflow-hidden relative max-h-screen">
        <div className="h-[600px] flex items-center justify-center">
          <div className="text-center space-y-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Loading transaction...
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full max-w-md mx-auto bg-white dark:bg-gray-900 rounded-3xl shadow-2xl overflow-hidden relative max-h-screen">
      <TransactionStatusScreen txId={txId} onBack={handleBack} />
    </div>
  )
}

export default TransactionStatusWidget
